import { PackageData } from "./PackageData";

export class CompareResult{
  pageSize: number;
  pageIndex: number;
  totalCount: number;
  pageData: PackageData[] = new Array()
}
